import { IPassengerWalletHistory } from "models/passengerWallet";

export default function WalletStatus(value: string) {
  const name = () => {
    if (value.toLowerCase() === "deduct") return "Deduct";
    if (value.toLowerCase() === "reward") return "Reward";
    if (value.toLowerCase() === "referral") return "Referral";
    return "Pop up";
  };

  const color = () => {
    const n = name();
    if (n === "Deduct") return "bg-red-500";
    if (n === "Reward") return "bg-purple-500";
    if (n === "Referral") return "bg-blue-500";
    return "bg-green-400";
  };

  return (
    <p className={`capitalize w-24 text-white text-center rounded-xl ${color()}`}>
      {name()}
    </p>
  );
}
